import { useLocation } from 'react-router-dom';
import qs from 'qs';

export default function useQS() {
  return qs.parse(useLocation().search, { ignoreQueryPrefix: true });
}
